/* SDD step-form guard: when Add to Cart is tapped before every step of a
   multi-step order form is complete, show a message, open the first
   incomplete step and highlight its missing required fields. */
(() => {
  if (window.__sddStepGuard) return;
  window.__sddStepGuard = true;
  const MSG = 'Please complete all steps before adding to cart.';
  const rootsFor = (form) => [...document.querySelectorAll('[data-step]')]
    .map((s) => s.parentElement)
    .filter((r, i, a) => r && a.indexOf(r) === i && r.querySelector('[data-finish]'))
    .filter((r) => r.contains(form) || [...r.querySelectorAll('input,select,textarea')].some((c) => c.form === form));
  const missing = (form) => [...form.elements].filter((el) =>
    el.required && !el.disabled && typeof el.checkValidity === 'function' && !el.checkValidity());
  const stepOf = (el) => Number(el.closest('[data-step]')?.dataset.step || 0);
  const visibleStep = (root) => {
    const s = [...root.querySelectorAll('[data-step]')].find((x) => !x.hidden);
    return s ? Number(s.dataset.step) : 0;
  };
  const setDim = (form) => {
    const btn = form.querySelector('[type="submit"][name="add"], [data-add-to-cart]');
    if (!btn || !rootsFor(form).length) return;
    btn.classList.toggle('sdd-atc-incomplete', missing(form).length > 0);
  };
  const showMessage = (root) => {
    let box = root.querySelector(':scope > .sdd-step-guard__msg');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('role', 'alert');
      box.className = 'sdd-step-guard__msg';
      const firstStep = root.querySelector(':scope > [data-step]');
      root.insertBefore(box, firstStep);
    }
    box.textContent = MSG;
    box.hidden = false;
  };
  const guide = (form, event) => {
    const roots = rootsFor(form);
    if (!roots.length) return;
    const bad = missing(form);
    if (!bad.length) return;
    const inSteps = bad.filter((el) => stepOf(el) > 0);
    if (!inSteps.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const root = roots.find((r) => r.contains(inSteps[0])) || roots[0];
    const target = Math.min(...inSteps.map(stepOf));
    const ready = root.querySelector('[class$="__ready"]');
    if (ready && !ready.hidden) root.querySelector('[data-edit]')?.click();
    let guard = 10;
    while (visibleStep(root) > target && guard--) {
      const back = root.querySelector('[data-step="' + visibleStep(root) + '"] [data-back]');
      if (!back) break; back.click();
    }
    while (visibleStep(root) < target && guard--) {
      const cur = visibleStep(root);
      const next = root.querySelector('[data-step="' + cur + '"] [data-next]');
      if (!next) break; next.click();
      if (visibleStep(root) === cur) break; // an earlier step is incomplete; its validation is shown
    }
    const section = root.querySelector('[data-step="' + visibleStep(root) + '"]');
    const fields = section ? missing(form).filter((el) => section.contains(el)) : [];
    fields.forEach((el) => { el.setAttribute('aria-invalid', 'true'); el.classList.add('sdd-field-missing'); });
    showMessage(root);
    const first = fields[0];
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      root.scrollIntoView({ block: 'start' });
      window.scrollBy(0, -90);
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    }));
  };
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[type="submit"][name="add"], [data-add-to-cart]');
    if (btn && btn.form) guide(btn.form, event);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.matches && event.target.matches('form[action*="/cart/add"]')) guide(event.target, event);
  }, true);
  const refresh = (event) => {
    const el = event.target;
    if (el && el.classList && el.classList.contains('sdd-field-missing') && el.checkValidity && el.checkValidity()) {
      el.classList.remove('sdd-field-missing'); el.setAttribute('aria-invalid', 'false');
    }
    document.querySelectorAll('form[action*="/cart/add"]').forEach(setDim);
    document.querySelectorAll('.sdd-step-guard__msg').forEach((box) => {
      const root = box.parentElement;
      const f = [...root.querySelectorAll('input,select,textarea')].map((c) => c.form).find(Boolean);
      if (f && !missing(f).length) box.hidden = true;
    });
  };
  ['input', 'change'].forEach((t) => document.addEventListener(t, refresh, true));
  document.addEventListener('click', () => window.setTimeout(() => refresh({}), 0));
  const init = () => document.querySelectorAll('form[action*="/cart/add"]').forEach(setDim);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  const css = document.createElement('style');
  css.textContent = '.sdd-atc-incomplete{opacity:.6}'
    + '.sdd-field-missing{border-color:#b00020 !important;box-shadow:0 0 0 1px #b00020}'
    + 'label:has(> input.sdd-field-missing[type=checkbox]),.sdd-hs-form__check:has(input.sdd-field-missing),.sdd-ged-form__check:has(input.sdd-field-missing){outline:2px solid #b00020;outline-offset:4px}'
    + '.sdd-step-guard__msg{color:#b00020;font-weight:600;margin:0 0 14px;padding:10px 12px;background:#fdf2f3;border-left:3px solid #b00020}.sdd-step-guard__msg[hidden]{display:none}';
  document.head.append(css);
})();
